import React from 'react'
import { Grid } from 'semantic-ui-react'
import FileUploadButton from '../../fileUploadButton'

const Images = ({ obj, onChange }) => {

  const visualDesktop = obj.picto ? obj.picto : null

  return (
    <div>
      <Grid columns={4}>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton id='picto' label='Visuel' image={visualDesktop} onChange={onChange} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

export default Images



// WEBPACK FOOTER //
// ./src/components/form/parking/images.js